import request from "utils/request";
import { baseRequestURL } from "api/BaseAPI";

export function sendInvite(tenantID, email, userAuth, noErrorToast = undefined) {
  return request(
    baseRequestURL + "v1/invites",
    {
      method: "POST",
      headers: { Authorization: "Bearer " + userAuth },
      body: JSON.stringify({
        email: email,
        tenant_id: tenantID
      })
    },
    true,
    undefined,
    noErrorToast
  ).then((response) => response);
}

export function removeFromTenant(tenantID, email, userAuth) {
  return request(
    baseRequestURL + "v1/tenant/" + tenantID + "/users",
    {
      method: "PATCH",
      headers: { Authorization: "Bearer " + userAuth },
      body: JSON.stringify({
        action: "remove",
        user: {
          email: email
        }
      })
    },
    true
  ).then((response) => response);
}

export function listInvites(userAuth) {
  return request(
    baseRequestURL + "v1/invites",
    {
      method: "GET",
      headers: { Authorization: "Bearer " + userAuth }
    },
    true
  ).then((response) => response);
}

export function respondToInvite(tenant_id, action, userAuth) {
  return request(
    baseRequestURL + "v1/invites",
    {
      method: "PATCH",
      headers: { Authorization: "Bearer " + userAuth },
      body: JSON.stringify({
        tenant_id: tenant_id,
        action: action
      })
    },
    true
  ).then((response) => response);
}

export function rejectInvite(tenant_id, userAuth) {
  return request(
    baseRequestURL + "v1/invites",
    {
      method: "DELETE",
      headers: { Authorization: "Bearer " + userAuth },
      body: JSON.stringify({
        tenant_id: tenant_id,
        action: "DELETED"
      })
    },
    true
  ).then((response) => response);
}
